<template>
  <div class="home">
   
      <app-sidebar></app-sidebar>

  <!-- Shop by category section -->
  <div class="wrapper-content">
     <app-header></app-header>


     <div class="breadcrumb_box">
        <div class="container-fluid">
            <h2>Help & Support</h2>
           
        </div>
    </div>

    <div class="addmoney">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="help-support panel">
                        <h2>Help & Support</h2>

                        <div class="help-tab">
                        <b-tabs content-class="mt-3">
                            <b-tab title="Report delivery issue" active>
                                <div class="container">
                                <form>
                                        <div class="form-group">
                                        <label for="comment">Write your feedback</label>
                                        <textarea class="form-control" rows="5" id="comment"></textarea>
                                    </div> 
                                    <button class="submit-btn">submit</button>
                                </form>
                                </div>
                            </b-tab>
                            <b-tab title="Report product issue">
                                <div class="container">
                                    <form>
                                            <div class="form-group">
                                            <select class="form-control" id="sel1">
                                            <option>Milk</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            </select>
                                        </div> 
                                            <div class="form-group">
                                            <label for="comment">Write your feedback</label>
                                            <textarea class="form-control" rows="5" id="comment"></textarea>
                                        </div> 
                                        <button class="submit-btn">submit</button>
                                    </form>
                                    </div>
                            </b-tab>
                        </b-tabs>
                        </div>


                           
                            
                    </div>
                </div>
            </div>
        </div>
    </div>  



      </div>
   
  <div ref="parentSidebar" id="parentx">
        <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'

export default {
  name: 'home',
  components: {
    'app-header': Header,
    'app-sidebar': Sidebar,
    'app-footer': Footer,
    // HelloWorld
  }
}
</script>
